import React from 'react';
import RichEditor from '../../form/RichEditor';
import {contentProps} from './content.props';

export class RichTextContent extends React.Component {
  static propTypes = {
    ...contentProps
  };

  changeRichText(body) {
    let { node, onChange } = this.props;

    onChange(node.setBody(body));
  }

  render() {
    let { node } = this.props;

    return (
      <div>
        <h6>Text</h6>
        <RichEditor
          style={{marginTop: -10, marginBottom: 0}}
          value={node.body}
          onChange={(body) => this.changeRichText(body)}
        />
      </div>
    );
  }
}

export default RichTextContent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/RichTextContent.js